module.exports = __webpack_public_path__ + "img/compact.1e8196a4.png";